import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observer } from 'mobx-react';
import { observable, computed } from 'mobx';
import * as moment from 'moment';
import { connect } from "react-redux";
import { Dispatch } from 'redux';

import { AllotmentAvailabilityView } from './allotment-availability.view';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { ContextService } from 'src/core/services/context.service';
import { actionAvailabilitiesCreators } from "src/store/allotments/availabilities-actions";

interface PropsFromState {
	availabilities: AvailabilityAllotments | null;
	otherLoadedEntities: ReadonlyArray<Readonly<{
		entity: ProductFormItemType
	}>>;
}
interface PropsFromDispatch {
	loadAvailabilities: (supplierId: number, allotment: AllotmentItem) => any;
}
interface Props extends ComponentViewProps<number> {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	defaultLanguaje: string;
	contextService: ContextService;
	idSuplier: number;
	suppliers: any[];
	allotment?: AllotmentItem
}

@observer
class AllotmentAvailabilityController extends React.Component<Props & PropsFromState & PropsFromDispatch, any> {
	@resolve
	protected dialogService: DialogService;

	@observable
	allotmentRangeDataByDay: AllotmentRangeDataByDay[];

	@observable
	year: number;

	constructor(props) {
		super(props);
		this.allotmentCurrent = this.props.availabilities
			? this.props.availabilities[this.props.idSuplier.toString()]
			: this.props.allotment ? this.props.allotment : null;
		this.year = this.getYear();
	}

	getYear() {
		if (this.allotmentCurrent && this.allotmentCurrent.allotmentRanges && this.allotmentCurrent.allotmentRanges.length > 0) {
			let rangeMin = this.allotmentCurrent.allotmentRanges.reduce((prev, current) => {
				if (prev.dateFrom <= current.dateFrom) {
					return prev;
				} else {
					return current;
				}
			});
			let date = moment.utc(rangeMin.dateFrom).startOf('day')
			return date.year();

		}
		else {
			return moment.utc().year();
		}
	}

	getDates(allotmentRange: AllotmentRangeItem, year: number): any[] {
		let dates = [];
		let today = moment.utc(allotmentRange.dateFrom).startOf('day');
		let toDate = moment.utc(allotmentRange.dateTo).startOf('day');

		while (today <= toDate) {
			if (today.year() == year) {
				dates.push(today);
			} else if (today.year() > year)
				break;
			today = moment.utc(today).add(1, 'days').startOf('day');
		}
		return dates;
	}

	allotmentCurrent: AllotmentItem;

	protected getTypeText(item: number): string {
		switch (item) {
			case 0:
				return 'StopSale';
			case 1:
				return 'By Availability';
			case 2:
				return 'By Request';
			case 3:
				return 'Unavailable';
			case 4:
				return 'Freesell';
			default:
				return 'UNDEFINDED';
		}
	}

	private refreshAvailability(idSupplier?: number, year?: number) {
		this.allotmentRangeDataByDay = [];
		if (idSupplier) {
			const allotmentInStore: AllotmentItem = this.props.otherLoadedEntities.find(e => e!= null && e.entity == this.allotmentCurrent.entity) as any;
			if (allotmentInStore.entity != null && allotmentInStore.allotmentRanges) {
				let ranges = allotmentInStore.allotmentRanges.filter(x =>x!= null && x.entity.dateFrom.getFullYear() <= year && x.entity.dateTo.getFullYear() >= year);
				for (let range of ranges) {
					let dates = this.getDates(range, year);
					let typeText = this.getTypeText(range.allotmentRangeType);
					let index = ranges.indexOf(range);
					const rangeInStore: AllotmentRangeItem = this.props.otherLoadedEntities.find(e =>e!= null && e.entity == range.entity) as any;
					for (let d of dates) {
						let data = this.allotmentRangeDataByDay.find(x => x.date.toString() == d.toString());
						let daily = (rangeInStore.allotmentRangeDailies != null) ? rangeInStore.allotmentRangeDailies.find(x => x.entity.date.toISOString() == d.toISOString() && x.entity.allotmentRangeId == rangeInStore.entity.id) : null;
						if (data == null) {
							let pushitem = {
								date: d,
								description: (range.dynamicProperties['translations']) ? range.dynamicProperties['translations'][this.props.defaultLanguaje] : '',
								allotmentRangeId: range.id,
								limit: range.totalLimit ? range.totalLimit : (daily != null) ? daily.dailyLimit : 0,
								allotmentRangeDailyId: (daily != null) ? daily.id : null,
								allotmentRangeType: range.allotmentRangeType,
								typeText: typeText,
								idAllotment: range.allotmentId,
								occupied: 0,
								index: index

							};

							this.allotmentRangeDataByDay.push(pushitem);
						} else if ((range.id && range.id > data.allotmentRangeId) || index >= data.index) {
							data.date = d;
							data.description = (range.dynamicProperties['translations']) ? range.dynamicProperties['translations'][this.props.defaultLanguaje] : '';
							data.allotmentRangeId = range.id;
							data.limit = range.totalLimit ? range.totalLimit : (daily != null) ? daily.dailyLimit : 0;
							data.allotmentRangeDailyId = (daily != null) ? daily.id : null;
							data.allotmentRangeType = range.allotmentRangeType;
							data.typeText = typeText;
							data.idAllotment = range.allotmentId;
							data.index = index;
						}

					}
				}
			}
		}

		return this.allotmentRangeDataByDay;
	}

	@autobind
	private AvailabilityAllotment(allotmentId?: number | null, idSupplier?: number, year?: number): Promise<AllotmentRangeDataByDay[]> {
		this.allotmentRangeDataByDay = [];
		this.year = year;
		if (idSupplier) {
			this.allotmentCurrent = this.props.availabilities
				? this.props.availabilities[idSupplier.toString()]
				: this.props.allotment ? this.props.allotment : null;
			const allotmentInStore: AllotmentItem = this.props.otherLoadedEntities.find(e => e != null && e.entity == this.allotmentCurrent.entity) as any;
			if (allotmentInStore) {
				if (allotmentInStore.id > 0 && (allotmentInStore.allotmentRanges == null || allotmentInStore.allotmentRanges.length == 0)) {
					return new Promise((resolve, reject) => {
						this.props.contextService.current().then(ctx =>
							ctx.AvailabilityAllotment(allotmentId, year).toArray()
								.then(res => {
									for (let item of res) {
										let typeText = this.getTypeText(item.allotmentRangeType);
										let allotmentRangeDataB = this.allotmentRangeDataByDay.find(x => x.date.toISOString() == item.date.toISOString());
										if (allotmentRangeDataB == null) {
											let pushitem = {
												date: moment.utc(item.date).startOf('day'),
												description: item.description,
												allotmentRangeId: item.allotmentRangeId,
												limit: item.limit,
												allotmentRangeDailyId: item.allotmentRangeDailyId,
												allotmentRangeType: item.allotmentRangeType,
												typeText: typeText,
												idAllotment: allotmentId,
												occupied: item.occupied,
												index: res.indexOf(item)

											};
											this.allotmentRangeDataByDay.push(pushitem)
										}

									}
									resolve(this.allotmentRangeDataByDay);
								})
								.catch(err => reject(err))
						);
					})
				}
				else {
					this.refreshAvailability(idSupplier, year);
					return new Promise((resolve, reject) => {
						resolve(this.allotmentRangeDataByDay);
					})
				}
			}
			else {
				if (this.allotmentCurrent && this.allotmentCurrent.id > 0 && (this.allotmentCurrent.allotmentRanges == null || this.allotmentCurrent.allotmentRanges.length == 0)) {
					return new Promise((resolve, reject) => {
						this.props.contextService.current().then(ctx =>
							ctx.AvailabilityAllotment(allotmentId, year).toArray()
								.then(res => {
									for (let item of res) {
										let typeText = this.getTypeText(item.allotmentRangeType);
										let allotmentRangeDataB = this.allotmentRangeDataByDay.find(x => x.date.toString() == item.date.toString());
										if (allotmentRangeDataB == null) {
											let pushitem = {
												date: moment.utc(item.date).startOf('day'),
												description: item.description,
												allotmentRangeId: item.allotmentRangeId,
												limit: item.limit,
												allotmentRangeDailyId: item.allotmentRangeDailyId,
												allotmentRangeType: item.allotmentRangeType,
												typeText: typeText,
												idAllotment: allotmentId,
												occupied: item.occupied,
												index: res.indexOf(item)

											};
											this.allotmentRangeDataByDay.push(pushitem)
										}

									}
									resolve(this.allotmentRangeDataByDay);
								})
								.catch(err => reject(err))
						);
					})
				}
				else {
					return new Promise((resolve, reject) => {
						resolve(this.allotmentRangeDataByDay);
					})
				}

			}
		} else {
			this.allotmentCurrent = null;
			return new Promise((resolve, reject) => {
				resolve(this.allotmentRangeDataByDay);
			})
		}
	}

	@autobind
	async Occupied(allotmentId: number, date: Date) {
		let occupied = await this.props.contextService.current().then(ctx =>
			ctx.Occupied(allotmentId, date));
		return occupied;
	}

	render(): JSX.Element {
		return (
			<AllotmentAvailabilityView
				year={this.year}
				avalabilities={this.props.availabilities}
				idSuplier={this.props.idSuplier}
				suppliers={this.props.suppliers}
				AvailabilityAllotment={this.AvailabilityAllotment}
				model={this.allotmentCurrent.id}
				setBusy={this.props.setBusy}
				Occupied={this.Occupied}
			/>
		);
	}
}

const mapStateToProps = (state: IApplicationState): PropsFromState => ({
	availabilities: state.availabilities,
	otherLoadedEntities: state.otherLoadedEntities,
});
const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
	loadAvailabilities: (supplierId: number, allotment: AllotmentItem) =>
		dispatch(actionAvailabilitiesCreators.loadAvailabilities(supplierId, allotment)),
});
const connected = connect(mapStateToProps, mapDispatchToProps)(AllotmentAvailabilityController);
export { connected as AllotmentAvailabilityController };



// WEBPACK FOOTER //
// ./src/app/products/allotment/form/parts/allotment-availability.controller.tsx